export default __webpack_public_path__ + "static/media/squid-moon-logo.e9e20179.svg";